export const table = `
  border-bottom: none;
  border-collapse: collapse;
  border-top: 1px solid #e4eaf4;
  line-height: 20px;
  table-layout: unset;
  text-align: left;
  width: 100%;
`;

export const thead = `
  background-color: #f8fafb;
  font-weight: 700;
`;

export const tr = `
  width: 100%;
  border-bottom: 1px solid #e4eaf4;
`;

export const th = `
  padding: 16px;
  color: #575757;
  font-weight: normal;
`;

export const td = `
  padding: 16px;
  color: #2b2b2b;
`;
